import React from 'react';
import GalleryPhotos from '../components/GalleryPhotos';
import PageHeader from './Shared/PageHeader';

const Gallery = () => {
    return (
        <div>
            <PageHeader title="Gallery Dark" />
            <GalleryPhotos />
        </div>
    );
};

export default Gallery;